export function calcContinuousApy(apr: number, days: number): number {
  const time = days / 365
  const apy = Math.exp(apr * time) - 1

  return apy
}
